module.exports = __webpack_public_path__ + "static/media/BOLL-Black.01c799f9.svg";